import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';

function Form({ token, dados, setDados, empresaId, empresaIds, handleSubmit, btnText, caminhoVoltar, OptionsEmpresa }) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    function handleChange(e) {
        const { name, value, type, checked } = e.target;
        let valor = value;
        if (name === 'capacidade') {
            valor = formatarNumeroDecimal(value);
        }
        setDados({ ...dados, [name]: type === 'checkbox' ? checked : valor });
    }
    async function handleOnBlur(e) {
        const { name, value, type, checked } = e.target;
        //verifica duplicidade
        if (name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'Almoxarifado', value);

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Almoxarifado/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Almoxarifado</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="Almoxarifado"
                    title="Digite o nome da Almoxarifado"
                    inputWidth="250px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required={true}
                />
                <InputNumber
                    text="Capacidade"
                    type="text"
                    name="capacidade"
                    placeholder="M³"
                    inputWidth="100px"
                    title="Capacidade de armazenagem em metros cúbicos M³"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.capacidade ? formatarNumero(dados.capacidade) : ''}
                    required={true}
                />

                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
